export default {"src":"https://cdn.jetlend.ru/_next/static/media/gloss.0aa36a0d.svg","height":32,"width":29,"blurWidth":0,"blurHeight":0};